var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { Select, Store } from '@ngxs/store';
import { EngineState } from 'src/app/engine/state/engine.state';
import { Observable, Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { EngineNodesState } from 'src/app/engine/state/nodes/engine.nodes.state';
var EngineBreadcrumbComponent = /** @class */ (function () {
    function EngineBreadcrumbComponent(graphService, store, changeDetection) {
        this.graphService = graphService;
        this.store = store;
        this.changeDetection = changeDetection;
        this.ngUnsubscribe = new Subject();
    }
    EngineBreadcrumbComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.hoveredNode$
            .pipe(filter(function (node) { return node != null; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (node) {
            _this.nodeAncestors = _this.getNodeAncestors(node)
                .map(function (ancestor) { return ancestor.label; })
                .slice(0, -1)
                .join(' > ');
            if (_this.nodeAncestors.length > 160) {
                _this.nodeAncestors = "..." + _this.nodeAncestors.slice(-160);
            }
            _this.changeDetection.markForCheck();
        });
    };
    EngineBreadcrumbComponent.prototype.ngOnDestroy = function () {
        this.changeDetection.detach();
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    EngineBreadcrumbComponent.prototype.getNodeAncestors = function (node) {
        var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
        return this.graphService
            .getAncestors(viewGraph, node.id, true)
            .map(function (id) {
            return viewGraph.nodes[id];
        })
            .reverse();
    };
    __decorate([
        Select(EngineNodesState.getHoveredNode),
        __metadata("design:type", Observable)
    ], EngineBreadcrumbComponent.prototype, "hoveredNode$", void 0);
    __decorate([
        Select(EngineNodesState.getCheckedNodes),
        __metadata("design:type", Observable)
    ], EngineBreadcrumbComponent.prototype, "checkedNodes$", void 0);
    return EngineBreadcrumbComponent;
}());
export { EngineBreadcrumbComponent };
